module.exports = __webpack_public_path__ + "media/female_resultD.741e76b5.mp3";